export default __webpack_public_path__ + "static/media/showcase-tax-vault.44bf8aa2.jpg";